import { Clock, Instagram, MapPin, Phone } from "lucide-react";
import { SnapchatIcon, TikTokIcon } from "@/components/TikTok";

const FOOTER_SOCIALS = [
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@slhphone69",
    Icon: TikTokIcon,
    testId: "footer-social-tiktok",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/slhphone69",
    Icon: Instagram,
    testId: "footer-social-instagram",
  },
  {
    name: "Snapchat",
    url: "https://www.snapchat.com/add/slhphone69",
    Icon: SnapchatIcon,
    testId: "footer-social-snapchat",
  },
];

export const Footer = ({ onNavigate }) => {
  return (
    <footer id="contact" className="relative border-t border-white/5 bg-[#050505]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-3 gap-14">
        <div>
          <img
            src="/assets/logo.png"
            alt="Logo SLH.PHONE — réparation téléphone à domicile Lyon"
            className="h-16 w-auto mix-blend-screen mb-6"
          />
          <p className="text-sm font-light leading-relaxed text-zinc-500 max-w-xs">
            Réparation de téléphones et smartphones à domicile à Lyon et dans
            toute la métropole. Écran, batterie, caméra : un technicien se
            déplace chez vous ou à votre bureau.
          </p>
          <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
            {FOOTER_SOCIALS.map(({ name, url, Icon, testId }) => (
              <a
                key={name}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Suivre SLH PHONE sur ${name}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-zinc-500 hover:border-[#0055FF] hover:text-[#0055FF] transition-colors duration-300"
                data-testid={testId}
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-white mb-6">
            Contact
          </h3>
          <ul className="space-y-4 text-sm font-light text-zinc-400">
            <li>
              <a href="tel:+33651487403" className="flex items-center gap-3 hover:text-white transition-colors duration-300" data-testid="footer-phone-link">
                <Phone className="h-4 w-4 text-[#0055FF]" /> 06 51 48 74 03
              </a>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-zone-info">
              <MapPin className="h-4 w-4 text-[#0055FF]" /> Lyon &amp; métropole — intervention à domicile
            </li>
            <li className="flex items-center gap-3" data-testid="footer-hours-info">
              <Clock className="h-4 w-4 text-[#0055FF]" /> Ouvert de 10h à 23h, 7j/7
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-white mb-6">
            Navigation
          </h3>
          <ul className="space-y-4 text-sm font-light text-zinc-400">
            {[
              { label: "Nos réparations", id: "#services" },
              { label: "Comment ça marche", id: "#processus" },
            ].map((link) => (
              <li key={link.id}>
                <button
                  onClick={() => onNavigate(link.id)}
                  className="nav-link hover:text-white transition-colors duration-300"
                  data-testid={`footer-link-${link.id.replace("#", "")}`}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            © 2026 SLH PHONE — Réparation téléphone à domicile à Lyon et les alentours.
          </p>
          <p className="text-xs text-zinc-700" data-testid="footer-demo-notice">
            Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};
